import MessageMedical from "assets/menu-icons/MessageMedical";
import projectConfig from "@/projectConfig";

const chatFeedBack = {
  id: 'chatFeedBack',
  type: 'group',
  visible: projectConfig.feedback,
  children: [{
    id: 'chatFeedBack',
    title: 'Обратная связь', 
    type: 'item',
    url: '/chatFeedBack',
    icon: MessageMedical,
    breadcrumbs: false,
    visible: projectConfig.feedback,
  }]
}

export default chatFeedBack;
